import Immutable from 'immutable';

import {
	createModuleState,
	createModelForState,
	webapi,
	REPORTED_EXCEPTION,
	StaticLookup,
	DateUtils,
} from 'ps-gui';
import {
	createSearchModel,
	getRawNsndTokenFilterProcessor,
} from '../utils';

const EMPTY_LIST = Immutable.List([]);
const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('Label');



export default class LabelModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new LabelModel(this.#data.setIn(name, value));
		} else {
			return new LabelModel(this.#data.set(name, value));
		}
	}

	#deleteProperty(name) {
		if (Array.isArray(name)) {
			return new LabelModel(this.#data.deleteIn(name));
		} else {
			return new LabelModel(this.#data.delete(name));
		}
	}

	#setInitialized() {
		return new LabelModel(this.#data.set('initialized', true));
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		let model = this;
		model = await model.initialize(globalContext);
		model = await model.refreshSearch(true);
		return model.#setProperty('languageTimestamp', new Date().getTime());
	}

	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}


	async openDetail(producerId, labelOwnershipId) {
		let res = await webapi.execute('/api/proc/api_labels/getlabel', {
			producerId,
			labelOwnershipId
		});
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		const detail = Immutable.fromJS(res);
		return this.#setProperty('detail', detail).#setProperty('originalDetail', detail);
	}

	setDetail(detail) {
		return this.#setProperty('detail', detail);
	}

	incListKey() {
		return this.#setProperty('listKey', (this.#data.get('listKey') || 0) + 1);
	}

	hideDetail() {
		return this.#setProperty('detail', null).#setProperty('originalDetail', null).incListKey();
	}

	async refreshSearch(dontSavePreference) {
		/*		let fixedFilter = {
			status_group: STATUS_GROUPS.filter(key => statusGroupFilter.get(key))
		};*/

		let srch = this.getSearch(); //.setFixedFilter(fixedFilter);
		if (!srch) {
			return this;
		}
		srch = await srch.search(1);
		return this.setSearch(srch);
	}

	async setPartyId(partyId) {
		let model = this.#setProperty('partyId', partyId);
		let srch = model.getSearch();
		srch = srch.setFixedFilter({
			producer_id: partyId
		});
		model = model.setSearch(srch);
		return model.refreshSearch();
	}

	async initialize() {
		console.log('initialize');

		let pi = await webapi.execute('/api/proc/api_labels/getpartyinfo', {});
		if (pi === REPORTED_EXCEPTION) {
			return this;
		}
		// console.log('pi = ', pi);
		let model = this.#setProperty('partyLookup', StaticLookup(Immutable.fromJS(pi.parties || [])));
		let partyId = pi?.parties[0]?.key;
		model = model.#setProperty('partyId', partyId);
		model = model.#setProperty('lockedFromDate', pi?.config?.lockedFromDate).#setProperty('lockedToDate', pi?.config?.lockedToDate);
		const isLocked = pi?.config?.lockedFromDate && DateUtils.isActiveDateRange(pi?.config?.lockedFromDate, pi?.config?.lockedToDate);
		model = model.#setProperty('isLocked', isLocked);
		let srch = createSearchModel('/api/dq/sv_producer_label').setEntityName('label');
		srch = srch.setFixedFilter({
			producer_id: partyId
		});
		srch = srch.setProcessFilter(getRawNsndTokenFilterProcessor(['label_name']));
		model = model.setSearch(srch).#setInitialized();
		model = await model.refreshSearch(true);
		return model;
	}

	setSearch(model) {
		return new LabelModel(this.#data.set('search', model.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}


